<template>
  <div class="normal-list" :class="{ no_border: noBorder }">
    <div class="list_title" v-if="title">
      <img :src="imgSrc" class="list_title_img" />
      <div class="title_box">
        <div>{{ title }}</div>
      </div>
    </div>
    <p class="more top" v-if="morePosition === 'top' && menu"><a :href="getHref(menu)">more</a></p>
    <div class="ul-first clearfix" v-if="showFirst && listData.length">
      <div class="time_box">
        <div>{{ listData[0].publishTime | getDay }}</div>
        <p>{{ listData[0].publishTime | getMoth }}</p>
      </div>
      <div class="news_box">
        <div>
          <a
            :href="
              listData[0].titleurl
                ? listData[0].titleurl
                : `${context}/frontend/showNews.html?hashcode=${listData[0].hashcode}`
            "
            target="_blank"
            :class="{ isRed: listData[0].redtitle == '是' }"
            >{{ listData[0].title }}</a
          >
        </div>
        <p>{{ listData[0].content | newsContent }}</p>
      </div>
    </div>
    <ul>
      <li v-for="(item, index) in listData" :key="index">
        <a
          :href="item.titleurl ? item.titleurl : `${context}/frontend/showNews.html?hashcode=${item.hashcode}`"
          target="_blank"
          :class="{ isRed: item.redtitle == '是' }"
          v-if="!(showFirst && index == 0)"
        >
          <span class="news_title">{{ item.title }}</span>
          <span class="news_time">{{ item.publishTime | formaTime(showYear) }}</span>
        </a>
      </li>
    </ul>
    <p class="more" v-if="!morePosition && menu"><a :href="getHref(menu)">more</a></p>
  </div>
</template>

<script>
import { getHref } from '@/utils';
export default {
  props: ['listData', 'title', 'icon', 'menu', 'imgSrc', 'showFirst', 'noBorder', 'morePosition', 'showYear'],
  filters: {
    formaTime: function(value, showYear = false) {
      let time = value.split('-');
      if (showYear) {
        return time[0] + '-' + time[1] + '-' + time[2];
      }
      return time[1] + '-' + time[2];
    },
    getDay: function(value) {
      let time = value.split('-');
      return time[2];
    },
    getMoth: function(value) {
      let time = value.split('-');
      return time[0] + '-' + time[1];
    },
    newsContent: function(value) {
      let div = document.createElement('div');
      div.innerHTML = value;
      return div.innerText.trim();
    },
  },
  methods: {
    getHref,
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variable.scss';
.normal-list {
  background: #fff;
  padding-bottom: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  border-bottom: 7px solid $theme_color;
  position: relative;
  .list_title {
    height: 160px;
    position: relative;
    .list_title_img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .title_box {
      position: absolute;
      background: $theme_color;
      text-align: center;
      color: #fff;
      width: 170px;
      height: 70px;
      left: 175px;
      bottom: 0;
      div {
        line-height: 70px;
        width: 100%;
        font-size: 28px;
      }
      a {
        font-size: 12px;
        color: #fff;
      }
    }
  }
  .ul-first {
    height: 50px;
    padding: 20px 10px;
    cursor: pointer;
    .time_box {
      width: 55px;
      height: 50px;
      background: $theme_color;
      color: #fff;
      text-align: center;
      float: left;
      div {
        font-size: 18px;
        font-weight: 700;
        padding-top: 7px;
      }
      p {
        font-size: 12px;
      }
    }
    .news_box {
      margin-left: 70px;
      font-size: 12px;
      div {
        @include overLine(1);
        color: #333;
        font-weight: 700;
      }
      p {
        margin-top: 3px;
        color: #666;
        @include overLine(2);
        max-height: 30px;
        overflow: hidden;
      }
    }
    .news_box:hover {
      a {
        color: $theme_color;
      }
    }
  }
  ul {
    padding: 0 10px;
    li {
      a {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 7px 0;
        color: #333;
        .news_title {
          @include overLine(1);
          font-size: 16px;
          width: 80%;
          &:before {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 6px;
            margin-right: 5px;
            /* margin-top: -5px; */
            content: '';
            background: #cd0200;
            transform: scale(0.8);
          }
        }
        .news_time {
          width: 14%;
          font-size: 12px;
          align-self: flex-end;
          text-align: end;
        }
        &:hover {
          color: #cd0200;
        }
      }
    }
  }
}
.no_border {
  box-shadow: none;
  border-bottom: none;
}
.isRed {
  color: red !important;
  span {
    color: red !important;
  }
}
.more {
  text-align: right;
  font-size: 14px;
  padding-right: 10px;
  &.top {
    position: absolute;
    top: 165px;
    right: 0px;
  }
  a {
    color: red!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/normalList/List.vue